/**
 * Redux async actions (src/store/actions/packagesActions.js).
 *
 * This module defines Redux Toolkit thunks (createAsyncThunk) that call backend endpoints via the shared axios client.
 * Slices consume the fulfilled payloads in `extraReducers` to update the UI state.
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../helpers/axiosconfig";

/**
 * Async thunk: fetchAllpackages.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const fetchAllpackages = createAsyncThunk(
  "packages/fetchAllpackages",
  async () => {
    const response = await axios.get(`getpackages`); // adjust the endpoint as needed
   
    return response.data;
  }
);

/**
 * Async thunk: Delete_Package.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const Delete_Package = createAsyncThunk(
  "packages/Delete_Package",
  async (id) => {
    const response = await axios.delete(`Delete_Package/${id}`);
    
    return response.data;
  }
);

/**
 * Async thunk: CreatePackage.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const CreatePackage = createAsyncThunk(
  "packages/CreatePackage",
  async (formdata) => {
    const response = await axios.post(`Add_Package`, formdata);
    return response.data;
  }
);

/**
 * Async thunk: updatePackage.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const updatePackage = createAsyncThunk(
  "packages/updatePackage",
  async ({ PackageID, formData }) => {
    const response = await axios.post(`Update_Package/${PackageID}`, formData);
    return response.data;
  }
);

/**
 * Async thunk: fetchPackage.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const fetchPackage = createAsyncThunk(
  "packages/fetchPackage",
  async (PackageID) => {
    const response = await axios.get(`fetchPackage/${PackageID}`);
    return response.data.package;
  }
);

/**
 * Async thunk: Search_Free_Package.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const Search_Free_Package = createAsyncThunk(
  "packages/Search_Free_Package",
  async () => {
    try {
      const response = await axios.get("Search_Free_Package");
      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
);

/**
 * Async thunk: fetchStudentPackages.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const fetchStudentPackages = createAsyncThunk(
  "packages/fetchStudentPackages",
  async (studentId) => {
    try {
      const response = await axios.get(`student-packages/${studentId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student packages:', error);
      throw error;
    }
  }
);

/**
 * Async thunk: SearchPackagebyPackageName.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const SearchPackagebyPackageName = createAsyncThunk(
  "packages/SearchPackagebyPackageName",
  async (input) => {
    try {
      const response = await axios.post(`SearchPackagebyPackageName/${input}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
);

/**
 * Async thunk: deductFreeHoursFromPackage.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const deductFreeHoursFromPackage = createAsyncThunk(
  "packages/deductFreeHours",
  async ({ packageId, hours, studentId }) => {
    
    const response = await axios.post(`packages/deductFreeHours`, { packageId, hours, studentId });
    return response.data;
  }
);

/**
 * Async thunk: addFreeHour.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const addFreeHour = createAsyncThunk(
  "packages/addFreeHour",
  async ({ StudentID, PackageID, Free_hour_used }) => {
    try {
      const response = await axios.post('use-free-hour', { StudentID, PackageID, Free_hour_used });
      return response.data;
    } catch (error) {
      console.error('Error using/returning free hour:', error);
      throw error;
    }
  }
);

/**
 * Async thunk: getStudentFreeHourUsage.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const getStudentFreeHourUsage = createAsyncThunk(
  "packages/getStudentFreeHourUsage",
  async (StudentID) => {
    try {
      const response = await axios.get(`student-free-hour-usage/${StudentID}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student free hour usage:', error);
      throw error;
    }
  }
);

/**
 * Async thunk: fetchPackagesWithCourses.
 *
 * Wraps an HTTP request (via the shared axios client) into a dispatchable Redux action.
 */
export const fetchPackagesWithCourses = createAsyncThunk(
  "packages/fetchPackagesWithCourses",
  async () => {
    try {
      const response = await axios.get(`packages-with-courses`);
      return response.data;
    } catch (error) {
      console.error('Error fetching packages with courses:', error);
      throw error;
    }
  }
);
